import { FunctionComponent } from 'preact';
import { route, RoutableProps } from 'preact-router';
import { Layout } from '../components/layout';

export const ForgotPasswordSentPage: FunctionComponent<RoutableProps> = () => {
  return (
    <Layout title="E-Mail gesendet" subtitle="Falls die Adresse bei uns registriert ist.">
      <div class="card mt-md">
        <p class="muted">
          Wir haben einen Link zum Zurücksetzen deines Passworts an die angegebene E-Mail-Adresse geschickt.
          Schau auch in den Spam-Ordner. Der Link ist nur eine begrenzte Zeit gültig.
        </p>
      </div>
      <button class="btn mt-md" onClick={() => route('/login')}>
        Zurück zur Anmeldung
      </button>
    </Layout>
  );
};
